module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "space"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("Helion & Company Limited"), _c('br'), _vm._v("\n26 Willow Road"), _c('br'), _vm._v("\nSolihull"), _c('br'), _vm._v("\nWest Midlands"), _c('br'), _vm._v("\nB91 1UE"), _c('br'), _vm._v("\nEngland"), _c('br'), _vm._v("\nTel. 0121 705 3393"), _c('br'), _vm._v("\nFax 0121 711 4075"), _c('br'), _vm._v("\nEmail: ")]), _c('a', {
    attrs: {
      "href": "mailto:info@helion.co.uk"
    }
  }, [_vm._v("info@helion.co.uk")]), _c('br'), _vm._v("\nWebsite: "), _c('a', {
    attrs: {
      "href": "http://www.helion.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.helion.co.uk")]), _c('br'), _vm._v("\nTwitter: @helionbooks"), _c('br'), _vm._v("\nVisit our blog "), _c('a', {
    attrs: {
      "href": "http://blog.helion.co.uk/",
      "target": "_blank"
    }
  }, [_vm._v("http://blog.helion.co.uk/")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Published by Helion & Company 2015"), _c('br'), _vm._v("\nDesigned and typeset by Bookcraft Ltd, Stroud, Gloucestershire"), _c('br'), _vm._v("\nCover designed by Paul Hewitt, Battlefield Design ("), _c('a', {
    attrs: {
      "href": "http://www.battlefield-design.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.battlefield-design.co.uk")]), _vm._v(")"), _c('br'), _vm._v("\nPrinted by Lightning Source Limited, Milton Keynes, Buckinghamshire")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Text © Vittorino del Cengio 2014"), _c('br'), _vm._v("\nImages and hand-drawn map © Paul Martelli 2014"), _c('br'), _vm._v("\nOther maps © Helion & Company Ltd 2015")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("ISBN: 978-1-909982-09-3"), _c('br'), _vm._v("\nDigital ISBN: 978-1-910777-52-7")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("British Library Cataloguing-in-Publication Data."), _c('br'), _vm._v("\nA catalogue record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in"), _c('br'), _vm._v("\na retrieval system, or transmitted, in any form, or by any means, electronic,"), _c('br'), _vm._v("\nmechanical, photocopying, recording or otherwise, without the express written"), _c('br'), _vm._v("\nconsent of Helion & Company Limited.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("For details of other military history titles published by Helion & Company Limited"), _c('br'), _vm._v("\ncontact the above address, or visit our website: "), _c('a', {
    attrs: {
      "href": "http://www.helion.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("http://www.helion.co.uk")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("We always welcome receiving book proposals from prospective authors.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e73a4ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Copyright.vue
// module id = 66
// module chunks = 0